import { render, staticRenderFns } from "./MainModal.vue?vue&type=template&id=66653c9c&scoped=true&"
import script from "./MainModal.vue?vue&type=script&lang=js&"
export * from "./MainModal.vue?vue&type=script&lang=js&"
import style0 from "./MainModal.vue?vue&type=style&index=0&id=66653c9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66653c9c",
  null
  
)

export default component.exports